<nav class="cabecera">
    <a class="regresar"><i class="fa fa-chevron-left" (click)="regresar()"></i></a>
    <h5>{{ prevtitle }} {{ title }}</h5>
    <a data-target="slide-out" class="sidenav-trigger"><i class="fa fa-bars"></i></a>
</nav>
<div class="container">
    <div class="row">
        <div class="col s6 relative center w46">
            <strong>{{ galpon }}</strong>
        </div>
        <div class="col s6 relative center w46">
            <strong>{{ title }}</strong>
        </div>
        <div class="col s12 relative" *ngIf="user.TipoPesaje != 2">
            <div *ngFor="let corral of corrales;" class="card horizontal" (click)="goToPesaje(corral.id, idlote)">
                <div class="col s2">
                    <p class="icon-mediano">
                        <i class="fa fa-briefcase"></i>
                    </p>
                </div>
                <div class="col s10">
                    <i class="nube fa fa-{{ corral.cloud }}"></i>
                    <div class="row mb0">
                        <div class="col s6">
                            <p class="mb0">Código:<br>
                                <strong>{{ corral.corral }}</strong>
                            </p>
                        </div>
                        <div class="col s6">
                            <p class="mb0">Semana :<br>
                                <strong>{{ cantidad_semanas[corral.id] || 0 }}</strong>
                            </p>
                        </div>
                    </div>
                    <p class="mt0">
                        Fecha de Creación<br>
                        {{ corral.fecha_creacion | date : 'yyyy-MM-dd HH:mm' }}
                    </p>
                </div>
            </div>
            <div *ngIf="corrales.length == 0">
                <p>&nbsp;</p>
                <p class="text-center">No se encontraron corrales</p>
            </div>
            <a (click)="agregarCorral(idlote)" class="btn-floating btn-large waves-effect waves-light red"><i class="fa fa-plus"></i></a>
        </div>
        <div class="col s12 relative" *ngIf="user.TipoPesaje == 2">
            <div *ngFor="let nac of nacimientos;" class="card horizontal" (click)="goToPesaje(nac.idNacimiento, idlote)">
                <div class="col s2">
                    <p class="icon-mediano">
                        <i class="fa fa-briefcase"></i>
                    </p>
                </div>
                <div class="col s10">
                    <i class="nube fa fa-{{ nac.cloud }}"></i>
                    <div class="row mb0">
                        <div class="col s6">
                            <p class="mb0">Código:<br>
                                <strong>{{ nac.CodCarga }}</strong>
                            </p>
                        </div>
                        <div class="col s6">
                            <p class="mb0"># Semanas:<br>
                                <strong>{{ nac.cantidad_semanas}}</strong>
                            </p>
                        </div>
                    </div>
                    <p class="mt0">
                        Fecha de Nacimiento<br>
                        {{ nac.fechaNacimiento | date : 'yyyy-MM-dd' }}
                    </p>
                </div>
            </div>
            <div *ngIf="nacimientos.length == 0 && Loading == false">
                <p>&nbsp;</p>
                <p class="text-center">No se encontraron Nacimientos</p>
            </div>
            <div *ngIf="nacimientos.length == 0 && Loading == true">
                <p>&nbsp;</p>
                <p class="text-center">Recopilando Nacimientos</p>
            </div>
        </div>
    </div>
</div>
<!-- Error Modal Structure -->
<div id="modal2" class="modal">
    <div class="modal-content" style="background-color: #c51b1b;">
        <h4 class="white-text">{{ alert_message }}</h4>
    </div>
</div>
